import { Slider } from '@statsbomb/kitbag-components';
import {
  OpenEnds,
  SliderOnChange,
  SliderOnDelete,
  SliderValues,
} from '@statsbomb/kitbag-components/types/components/Inputs/Slider/types';
import { useSliderLabel } from '@/hooks/useSliderLabel';

export const SliderMultiple = ({
  title,
  range: [minRange, maxRange],
  selectedRange,
  setSelectedRange,
  step,
  openEnds,
  isReversed,
  onDelete,
}: {
  title: string;
  range: SliderValues;
  selectedRange: [number | undefined, number | undefined];
  setSelectedRange: (range: [number | undefined, number | undefined]) => void;
  step?: number;
  openEnds?: OpenEnds;
  isReversed?: boolean;
  onDelete?: SliderOnDelete;
}) => {
  const formattedLabel = useSliderLabel(selectedRange[0], selectedRange[1]);

  const labels = [
    { label: minRange.toString(), position: minRange },
    { label: maxRange.toString(), position: maxRange },
  ];

  const onChange: SliderOnChange = (_, range) => {
    // This can't actually happen provided range is an array, which it is always guaranteed to
    // be.
    /* istanbul ignore if */
    if (typeof range === 'number') {
      // eslint-disable-next-line no-console
      console.error("SliderMultiple: Range shouldn't be a single value");
      return;
    }

    setSelectedRange(range);
  };

  const sliderId = title.toLowerCase().replace(/\s+/g, '-');

  return (
    <Slider
      id={sliderId}
      label={title}
      labels={labels}
      min={minRange}
      max={maxRange}
      onChange={onChange}
      // TODO (EPT-18519: remove tsignore) - remove when the types are fixed.
      // @ts-ignore - types for this value don't support undefined at the moment, even though it does work
      value={selectedRange}
      valueLabel={formattedLabel}
      step={step}
      openEnds={openEnds}
      isReversed={isReversed}
      onDelete={onDelete}
      testId={`${sliderId}-slider`}
    />
  );
};
